export default __webpack_public_path__ + "images/f47a663fb8ab7f0bdac9e855ebe825dc-photography.webp";